import React from 'react'
import { motion } from 'framer-motion'
import Header from './header'
import MobileHeader from './mobileHeader'
import Footer from './footer'
import { pageVariant } from '../animation'
import MoveUp from './moveUp'
import Background from '../animation/background'

const Liberyus = ({ children }) => {
    return (
        <div className='main'>
            <Header />
            <MobileHeader />
            <Background />

            <motion.div {...pageVariant}>
                {children}
            </motion.div>

            <MoveUp />
            <Footer />
        </div>
    )
}

export default Liberyus
